import API_BASE from './config';
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        
        try {
            const res = await axios.post(`${API_BASE}/api/token/`, credentials);
            // Save the tokens for future API calls
            localStorage.setItem('access_token', res.data.access);
            localStorage.setItem('refresh_token', res.data.refresh);
            navigate('/portal');
        } catch (err) {
            setError('INVALID CREDENTIALS. ACCESS DENIED.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#050505] p-6">
            <div className="w-full max-w-md bg-white/[0.03] border border-white/5 p-10 rounded-[2.5rem] backdrop-blur-xl shadow-2xl">
                <div className="text-center mb-8">
                    <div className="inline-block bg-sky-500/10 text-sky-500 text-[9px] font-black px-3 py-1 rounded-full uppercase tracking-widest mb-4">
                        Secure Access Point
                    </div>
                    <h2 className="text-3xl font-black text-white uppercase tracking-tighter">
                        Organiser<span className="text-sky-500">Login</span>
                    </h2>
                </div>

                <form onSubmit={handleLogin} className="space-y-4">
                    <div className="space-y-1">
                        <label className="text-[9px] font-black text-gray-500 uppercase ml-2 tracking-widest">Identification</label>
                        <input 
                            type="text" 
                            required
                            placeholder="USERNAME" 
                            className="w-full bg-black border border-white/10 p-4 rounded-2xl text-white font-bold focus:border-sky-500 transition-all outline-none"
                            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-[9px] font-black text-gray-500 uppercase ml-2 tracking-widest">Authentication</label>
                        <input 
                            type="password" 
                            required
                            placeholder="PASSWORD" 
                            className="w-full bg-black border border-white/10 p-4 rounded-2xl text-white font-bold focus:border-sky-500 transition-all outline-none"
                            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                        />
                    </div>

                    {error && <p className="text-red-500 text-[10px] font-bold uppercase text-center animate-pulse">{error}</p>}
                    
                    <button 
                        disabled={loading}
                        className={`w-full bg-sky-500 text-black font-black py-4 rounded-2xl uppercase tracking-widest transition-all active:scale-95 ${loading ? 'opacity-50' : 'hover:shadow-[0_0_20px_rgba(14,165,233,0.3)]'}`}
                    >
                        {loading ? 'Authenticating...' : 'Enter Portal'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;